export enum PrimeFilter {
  UserType = 'userType',
  Database = 'db',
  Traits = 'traits',
  SearchType = 'searchType',
}
